import React, { useEffect, useState } from 'react';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Box, Button, Grid, Modal, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import validators from '../../utils/validators';
import { Link } from 'react-router-dom';
import CustomDivider from '../../components/CustomDivider';
import { TextFieldComponent } from '../../components/CustomFormElement';
import { PasswordHideWhiteIcon, PasswordShowWhiteIcon } from '../../components/CustomIcons';

const useStyles = makeStyles((theme) => ({
    link: {
        color: theme.palette.text.link,
        textDecoration: 'none',
    },
    button: {
        textTransform: 'capitalize!important',
        marginRight: `${theme.spacing(2)}!important`,
    },
}));

export default function RegisterIdentifyViewV2(props) {
    const { handleVerification } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    const [isChangeIcon, setChangeIcon] = useState(false);
    const onChangeIconPass = () => {
        setChangeIcon(!isChangeIcon);
    }
    
    return (
        <div>
            <Form
                onSubmit={handleVerification}
                render={({ handleSubmit, values }) => (
                    <Grid xs={12}  container item justify="center" alignItems="center" >
                        <Grid xs={12} item container justifyContent="center" marginBottom={6}>
                            <Grid xs={12} item>
                                <Grid xs={12} item container justifyContent="center">
                                    <Typography variant="h1" color="primary">{t('registration')}</Typography>
                                </Grid>
                                <Grid item xs={12} container justifyContent="center" marginTop={2}>
                                    <Typography variant="body1" color="textSecondary">
                                        {t('Please add credentials for signing into the app')}
                                    </Typography>
                                </Grid>
                                <Grid xs={12} item container justifyContent="center" marginTop={2}>
                                    <CustomDivider />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid xs={12} item style={{ textAlign: 'center', width: '100%' }}>
                            <Grid xs={12} item>
                                <Field
                                    fullWidth
                                    name="email"
                                    component={TextFieldComponent}
                                    placeholder={t('email_address')}
                                    validate={validators.composeValidators(validators.validEmail)}
                                />
                            </Grid>
                            <Grid xs={12} item style={{ textAlign: 'center', width: '100%' }}>
                                <Field
                                    name="password"
                                    component={TextFieldComponent}
                                    placeholder={t('password')}
                                    type={isChangeIcon ? 'text' : 'password'}
                                    validate={validators.composeValidators(validators.required)}
                                    endAdornment={<Grid style={{ cursor: 'pointer' }} onClick={onChangeIconPass}>{isChangeIcon ? <PasswordShowWhiteIcon /> : <PasswordHideWhiteIcon />}</Grid>}
                                />
                            </Grid>
                            <Grid xs={12} item style={{ textAlign: 'center', width: '100%' }}>
                                <Field
                                    name="password_confirmation"
                                    component={TextFieldComponent}
                                    placeholder={t('Password Confirmation')}
                                    type={isChangeIcon ? 'text' : 'password'}
                                    validate={validators.composeValidators(
                                        validators.required,
                                        value => validators.validNotMatchPassword(value, values.password)  
                                    )}
                                    endAdornment={<Grid style={{ cursor: 'pointer' }} onClick={onChangeIconPass}>{isChangeIcon ? <PasswordShowWhiteIcon /> : <PasswordHideWhiteIcon />}</Grid>}
                                />
                            </Grid>

                        </Grid>
                        <Grid xs={12} item container style={{ width: '100%' }}>
                            <Grid xs={12} item>
                                <Grid item xs={12} container marginTop={2} className={classes.content_link}>
                                    <Typography variant="body2" color="red">
                                        {t('The password:')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} container marginTop={1} marginLeft={2} className={classes.content_link}>
                                    <Typography variant="body1" color="red">
                                        {t('1) must be at least 8 characters long.')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} container marginTop={1} marginLeft={2} className={classes.content_link}>
                                    <Typography variant="body1" color="red">
                                        {t('2) may contain alphanumeric characters')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} container marginTop={1} marginLeft={2} className={classes.content_link}>
                                    <Typography variant="body1" color="red">
                                        {t('3) may contain special characters')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} container marginTop={1} marginLeft={2} className={classes.content_link}>
                                    <Typography variant="body1" color="red">
                                        {t('4) may not contain a sequence of characters or numbers (e.g. "avgdezi" or "12345")')}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid xs={12} item marginTop={3}>
                                <Box flex={1}>
                                    <Button variant="contained" color="primary" fullWidth={true} onClick={handleSubmit} className={classes.button}>{t('Submit')}</Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            />

        </div>
    );
}
